import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import { InsertedProductToBasket } from "../basketHooks";

interface ProductInsertedToBasketModalProperties {
    readonly basketPageUrl: string;
    readonly modalIsOpen: boolean;
    readonly closeModal: () => void;
    readonly product: InsertedProductToBasket;
    readonly onAfterClose: () => void;
}

export default function ProductInsertedToBasketModal({
    basketPageUrl,
    modalIsOpen,
    closeModal,
    product,
    onAfterClose,
}: ProductInsertedToBasketModalProperties): React.JSX.Element {
    const { t } = useTranslation("basket");

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="modal-dialog shop-modal-change"
            overlayClassName="react-modal-backdrop modal-transition"
            closeTimeoutMS={150}
            onAfterClose={(): void => onAfterClose()}
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body shop-body">
                    <div className="cart-modal-container">
                        <div className="cart-modal-left">
                            <img src={product.imageUrl} alt="" />
                        </div>
                        <div className="cart-modal-right">
                            <i className="fa-solid fa-check-circle"></i>
                            <span className="addtocart">{t("addedToCart")}</span>
                            <h3>
                                {product.title}
                                {product.isMultivariant
                                  && <span className="addtocart-green">{t("variant")} {product.id}</span>}
                            </h3>
                        </div>
                    </div>
                    <div className="shop-button">
                        <a onClick={closeModal}>{t("continueShopping")}</a>
                        <a className="btn btn-success" href={basketPageUrl}>{t("goToCart")}</a>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
